import Resource from './Resource';

export default class ThirdPartyAccess extends Resource{
	constructor(options={}) {
		let {
			routeParams = {},
			query = {},
			data = {}
		} = options;

		let route = !!routeParams.clientId ? `third-party-access/:clientId` : 'third-party-access';
		
		let config = {
			route: route,
			routeParams: routeParams,
			query: query,
			data: data
		};

		super(config);
		return this;
	}

	get() {
		return this.request();
	}

	delete() {
		return this.request('delete');
	}

}
